import { createRootRoute } from '@tanstack/react-router';

import App from '@/app';
import { NotFound } from '@/containers/not-found';
import '../i18n/index.ts';
import Providers from '@/providers/providers.tsx';

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => {
    return <NotFound />;
  },
});

function RootComponent() {
  return (
    <Providers>
      <App />
    </Providers>
  );
}
